<template>
  <!-- 修改弹窗 -->
  <div>
    <BaseDialog title="修改" :isshow="visible" @handleShow="handleShows" width="700px" height="auto">
      <!-- 内容-->
      <el-descriptions :column="3" size="small" border style="margin-top:10px;">
        <el-descriptions-item label="药品名称">{{ drug.name }}</el-descriptions-item>
        <el-descriptions-item label="规格">{{ drug.medi_spec }}</el-descriptions-item>
        <el-descriptions-item label="类别">{{ drug.fee_type }}</el-descriptions-item>
        <el-descriptions-item label="生产厂家">{{ drug.company }}</el-descriptions-item>
      </el-descriptions>
      <div class="addform" style="margin-top:10px;">
        <el-form :model="ruleFormEdit" ref="ruleFormEditRef" label-width="120px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="批号">
                <el-input v-model="ruleFormEdit.batch_no" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="入库数量">
                <el-col :span="6">
                  换算系数 {{ drug.min_package_num }}
                </el-col>
                <el-col :span="8">
                  <el-input v-model="ruleFormEdit.enter_num" placeholder="">
                    <template #append>{{ drug.min_package_unit_name }}</template>
                  </el-input>
                </el-col>
                <el-col :span="2"></el-col>
                <el-col :span="8">
                  <el-input v-model="ruleFormEdit.enter_sub_num" placeholder="">
                    <template #append>{{ drug.min_unit_name }}</template>
                  </el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="进货单位">
                <el-input disabled v-model="drug.min_package_unit_name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="进价">
                <el-input v-model="ruleFormEdit.buy_price" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="采购总价">
                <template #default="scope">
                  <span v-if="drug.min_package_num">{{ (ruleFormEdit.buy_price *
                    ruleFormEdit.enter_num +
                    ruleFormEdit.buy_price *
                    ruleFormEdit.enter_sub_num
                    / drug.min_package_num).toFixed(2) }}</span>
                  <span v-else>0.00</span>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="零售单位">
                <el-input disabled v-model="drug.dict_first_unit_name" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="零售价">
                <el-input v-model="ruleFormEdit.price" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="零售总价">
                <template v-if="drug.min_package_num">
                  <template v-if="drug.dict_first_unit == drug.min_package_unit">
                    {{
                    (Number(ruleFormEdit.price) * Number(ruleFormEdit.enter_num) +
                    Number(ruleFormEdit.price) *
                    Number(ruleFormEdit.enter_sub_num) /
                    Number(drug.min_package_num)).toFixed(2)
                    }}
                  </template>
                  <templage v-else-if="drug.dict_first_unit == drug.min_unit">
                    {{
                    ((Number(ruleFormEdit.enter_num) * Number(drug.min_package_num) +
                    Number(ruleFormEdit.enter_sub_num)) * Number(ruleFormEdit.price)).toFixed(2)
                    }}
                  </templage>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item label="有效期">
                <el-date-picker v-model="ruleFormEdit.validity_end_time" value-format="YYYY-MM-DD" type="date"
                  placeholder="有效期至" style="width: 100%" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="优先出库">
                <el-checkbox v-model="ruleFormEdit.first_out" label=""></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="供应商">
                <el-input v-model="ruleFormEdit.supplier" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input v-model="ruleFormEdit.remark" type="textarea" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-divider />
      <div style="text-align: right">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="handleEdit()" :loading="saveLoad">确定</el-button>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
  import { toRefs, reactive, onMounted } from 'vue'
  import service from '@/utils/request'
  import { downLoadXlsx, TimestampToTime } from '@/utils/tool'
  import BaseDialog from '@/components/Dialog/index.vue'
  export default {
    components: {
      BaseDialog,
    },
    props: {
      dictCatalogType: {
        type: String,
        default: '',
      }
    },
    setup(props1, ctx) {
      const state = reactive({
        visible: false,
        ruleFormEdit: {},//首页退货
        drug: '',
        saveLoad:false
      })
      const initData = (row, drug) => {
        state.visible = true
        state.ruleFormEdit = row
        state.drug = drug
      }
      // 编辑
      const handleEdit = async () => {
        state.saveLoad = true
        let url = '/api/store_enter_record/edit_record'
        await service.post(url, state.ruleFormEdit)
        state.visible = false
        state.saveLoad = false
        ctx.emit('refreshDataList', state.ruleFormEdit)
        state.ruleFormEdit = {}
      }
      // 弹窗取消
      const cancel = () => {
        state.visible = false
        state.ruleFormEdit = ''
        state.drug = ''
      }
      return {
        ...toRefs(state),
        initData,
        handleEdit,
        cancel
      }
    },
  }
</script>

<style scoped lang="scss">
  
</style>